export enum EButtonType {
  Primary = 'primary',
  Secondary = 'secondary',
  Tertiary = 'tertiary',
  Branding = 'branding',
  BrandingSecondary = 'branding-secondary',
  PrimaryLoadText = 'primary-load-text', // deprecated
}
